module.exports = __webpack_public_path__ + "img/HC1035-112.fa794764.jpg";